import React from "react";

import { MONETIC_MARKS } from "@constants/index";

import { AdyenConfiguration } from "./AdyenConfig";
import { ValinaConfig } from "./ValinaConfig";
import { NeptingConfig } from "./NeptingConfig";
import { ValinaSwissConfig } from "./ValinaSwisseConfig";
import { YavinConfig } from "./YavinConfig";
import { useMoneticsForm } from "./MoneticsFormContext";

/**
 * Renders the brand-specific configuration block for the selected mark.
 * Each brand config reads what it needs from the MoneticsForm context, so this
 * is a pure `mark` dispatcher with no prop forwarding.
 */
export function MoneticConfigSwitch() {
    const { form } = useMoneticsForm();
    const { mark } = form;

    if (mark === MONETIC_MARKS.VALINA) {
        return <ValinaConfig />;
    }

    if (mark === MONETIC_MARKS.NEPTING) {
        return <NeptingConfig />;
    }

    if (mark === MONETIC_MARKS.ADYEN) {
        return <AdyenConfiguration />;
    }

    if (mark === MONETIC_MARKS.VALINA_SWISS) {
        return <ValinaSwissConfig />;
    }

    if (mark === MONETIC_MARKS.YAVIN) {
        return <YavinConfig />;
    }

    return null;
}
